/**
 * Workspace bootstrap eligibility — ignores a lone static tab intro raced ahead of project load.
 * @param {unknown} msg
 */
export function isStaticTabIntroMessage(msg) {
  return Boolean(msg && typeof msg === "object" && msg.staticTabIntro === true);
}

/**
 * @param {unknown[]} messages
 */
export function shouldRunWorkspaceBootstrap(messages) {
  if (!Array.isArray(messages) || messages.length === 0) return true;
  if (messages.length === 1 && isStaticTabIntroMessage(messages[0])) return true;
  return false;
}

/**
 * @param {unknown[]} messages
 */
export function hasLeadingStaticTabIntroOnly(messages) {
  return Array.isArray(messages) && messages.length === 1 && isStaticTabIntroMessage(messages[0]);
}
